import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { gespeichertesTheme, themeAnwenden } from "./lib/theme";
import "./styles.css";

// Vor dem ersten Zeichnen, damit die Oberfläche nicht hell aufblitzt.
themeAnwenden(gespeichertesTheme());

const root = document.getElementById("root");
if (!root) throw new Error("Wurzelelement fehlt");
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
